import { root } from '../../../../store/constants';
import { userIdentifyTraitsSelector } from '../../selectors/userIdentifyTraitsSelector';

export const identify = (inputTraits: any) => {
    if (root.App.controller.demo) return;
    const traits = userIdentifyTraitsSelector();
    root.analytics && root.analytics.identify(traits.id, {
        ...traits,
        ...inputTraits
    });
};
